import { useQuery } from "react-query";
import {
  getCategory,
  getCities,
  getDistrcit,
  getNewsChannel,
  getNewsPaper,
  getPublicServiceCategory,
  getServiceLink,
  getState,
  getSubCategory,
  getAds,
  getExtraSubCategories,
  getExtraProducts,
  getExtraItems,
  getInfluencerCategories,
} from "./commonQueryUrl";

const Get_district = (id) => {
  return useQuery(["district", id], () => getDistrcit(id), {
    enabled: !!id,
  });
};
const Get_cities = (id) => {
  return useQuery(["city", id], () => getCities(id), {
    enabled: !!id,
  });
};

const Get_state = () => {
  return useQuery(["state"], () => getState());
};
const Get_public_serivce = (query) => {
  return useQuery(
    ["publicService", query], 
    () => getPublicServiceCategory(query),
    {
      retry: false, // Disable retries to prevent infinite loops
      retryOnMount: false, // Don't retry on component mount
      refetchOnWindowFocus: false, // Don't refetch on window focus
      staleTime: 5 * 60 * 1000, // 5 minutes stale time
      cacheTime: 10 * 60 * 1000, // 10 minutes cache time
      onError: (error) => {
        console.log('🏛️ Public Service API Error:', error);
        // Don't throw error to prevent component crashes
      }
    }
  );
};

const Get_category = (query) => {
  return useQuery(["category", query], () => getCategory(query));
};

const Get_channel = (query) => {
  return useQuery(["newsChannel", query], () => getNewsChannel(query));
};
const Get_newsPaper = (query) => {
  return useQuery(["newsPaper", query], () => getNewsPaper(query));
};

const Get_subcategory = (query) => {
  return useQuery(["subcategory", query], () => getSubCategory(query), {});
};

const Get_service_link = (query) => {
  return useQuery(["serviceLink", query], () => getServiceLink(query), {});
};

const Get_ads = (query) => {
  return useQuery(["ads", query], () => getAds(query), {
    enabled: !!(query?.lat && query?.lon), // Only run when lat and lon are available
  });
};

const Get_extra_subcategories = (query) => {
  return useQuery(["extraSubCategories", query], () => getExtraSubCategories(query));
};

const Get_extra_products = (query) => {
  return useQuery(["extraProducts", query], () => getExtraProducts(query));
};

const Get_extra_items = (query) => {
  return useQuery(["extraItems", query], () => getExtraItems(query));
};

const Get_influencer_categories = () => {
  return useQuery(["influencerCategories"], () => getInfluencerCategories(), {
    staleTime: 5 * 60 * 1000,
  });
};

const useCommonQuery = {
  Get_district,
  Get_cities,
  Get_state,
  Get_category,
  Get_channel,
  Get_newsPaper,
  Get_subcategory,
  Get_public_serivce,
  Get_service_link,
  Get_ads,
  Get_extra_subcategories,
  Get_extra_products,
  Get_extra_items,
  Get_influencer_categories,
};

export default useCommonQuery;
